<template>
  <div >
    <NavTop class="navbar">
      <template v-slot:mainnavlist>
        <!--        <div @click="routerpush('/home')">首页</div>-->
        <el-dropdown class="dropdown" >
          <span class="el-dropdown-link" >
            学校概括<i class=""></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="dropdown_menu">
            <el-dropdown-item ><div @click="navigateTo('/profiles')" >学校简介</div></el-dropdown-item>
            <el-dropdown-item><div @click="navigateTo('/leader')" >现任领导</div></el-dropdown-item>
            <el-dropdown-item><div @click="navigateTo('/nav')" >校园导航</div></el-dropdown-item>
            <el-dropdown-item >VR全景校园</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="header_nav" @click="navigateTo('/institution')">机构设置</div>
        <el-dropdown class="dropdown">
          <span class="el-dropdown-link" >
            党建原地<i class=" "></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="dropdown_menu">
            <el-dropdown-item><div @click="navigateTo('/partyActive')" >党建活动</div></el-dropdown-item>
            <el-dropdown-item><div @click="navigateTo('/partySystem')" >相关制度</div></el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="header_nav" @click="navigateTo('/')">教师研修</div>
        <el-dropdown class="dropdown">
          <span class="el-dropdown-link" >
            招生就业<i class=" "></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="dropdown_menu">
            <el-dropdown-item>招生信息</el-dropdown-item>
            <el-dropdown-item>就业信息</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="header_nav" @click="navigateTo('talents')">人才培养</div>
        <el-dropdown class="dropdown">
          <span class="el-dropdown-link" >
            走进东方<i class=""></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="dropdown_menu">
            <el-dropdown-item><div @click="navigateTo('/life')" >校园生活</div></el-dropdown-item>
            <el-dropdown-item><div @click="navigateTo('/schoolStyle')" >校园风采</div></el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="header_nav" @click="navigateTo('/')">学生服务</div>
      </template>
    </NavTop>
    <div class="center">
      <div class="center" ref="targetDiv" style="margin: 30px 40px">
        <div class="right_box">
          <div class="row between border_bottom">
            <div class="title">校园生活</div>
            <div class="right_link"><router-link class="link"  to="/">首页</router-link> / <router-link class="link" to="/style">校园风采</router-link></div>
          </div>
          <div class="part_box" v-for="(item,index) in partList" :key="index">
            <img :src='item.img'>
            <div class="part">
              <div class="part_title">
                <router-link class="link" to="/detils">{{ item.title }}</router-link>
              </div>
              <div class="content">
                {{item.content}}
                <div class="date">{{item.date}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import NavTop from '../../../components/comcomponents/NavTop.vue'

export default {
  components: {NavTop},
  data () {
    return {
      navItems: [
        {name: '首页', path: '/home'},
        {name: '学校简介', path: '/profiles'},
        {name: '现任领导', path: '/leader'},
        {name: '学院导航', path: '/nav'},
        {name: 'VR校园全景', path: '/vr'},

      ],
      partList:[
        {img:'',date:'2024-10-21',title: '读书月系列活动||我校成功举办毛泽东经典诗词诵读会',content:'  为深入学习领会习近平总书记在纪念毛泽东同志诞辰130周年座谈会上重要讲话的精神实质和丰富内涵，切实把思想和行动统一到讲话精神上，传承和弘扬毛泽东诗词文化，提高学生们的语言表达能力和艺术鉴赏能力，激发爱国情怀和奋斗精神。我校于5月15日在文华楼210报告厅成功举办了读书月系列活动——毛泽东经典诗词诵读会     比赛正式拉开帷幕，参赛者依次上场，吟咏慨叹间，结合各个创作风格与背景各异的诗词篇目，充分展现了毛泽东诗词蓬勃的艺术魅力。   毛泽东诗词犹如夏日的繁星，闪烁着夺目的光彩；又犹如春日的百花，散发着馥郁的芳香。聆听“北国风光，千里冰封，万里雪飘”的豪迈与奔放；感受“五岭逶迤腾细浪，乌蒙磅礴走泥丸”的坚定与执着；品味“雄关漫道真如铁，而'},
        {img:'',date:'2024-10-21',title: '读书月系列活动||我校成功举办毛泽东经典诗词诵读会',content:'  为深入学习领会习近平总书记在纪念毛泽东同志诞辰130周年座谈会上重要讲话的精神实质和丰富内涵，切实把思想和行动统一到讲话精神上，传承和弘扬毛泽东诗词文化，提高学生们的语言表达能力和艺术鉴赏能力，激发爱国情怀和奋斗精神。我校于5月15日在文华楼210报告厅成功举办了读书月系列活动——毛泽东经典诗词诵读会     比赛正式拉开帷幕，参赛者依次上场，吟咏慨叹间，结合各个创作风格与背景各异的诗词篇目，充分展现了毛泽东诗词蓬勃的艺术魅力。   毛泽东诗词犹如夏日的繁星，闪烁着夺目的光彩；又犹如春日的百花，散发着馥郁的芳香。聆听“北国风光，千里冰封，万里雪飘”的豪迈与奔放；感受“五岭逶迤腾细浪，乌蒙磅礴走泥丸”的坚定与执着；品味“雄关漫道真如铁，而'},
        {img:'',date:'2024-10-21',title: '读书月系列活动||我校成功举办毛泽东经典诗词诵读会',content:'  为深入学习领会习近平总书记在纪念毛泽东同志诞辰130周年座谈会上重要讲话的精神实质和丰富内涵，切实把思想和行动统一到讲话精神上，传承和弘扬毛泽东诗词文化，提高学生们的语言表达能力和艺术鉴赏能力，激发爱国情怀和奋斗精神。我校于5月15日在文华楼210报告厅成功举办了读书月系列活动——毛泽东经典诗词诵读会     比赛正式拉开帷幕，参赛者依次上场，吟咏慨叹间，结合各个创作风格与背景各异的诗词篇目，充分展现了毛泽东诗词蓬勃的艺术魅力。   毛泽东诗词犹如夏日的繁星，闪烁着夺目的光彩；又犹如春日的百花，散发着馥郁的芳香。聆听“北国风光，千里冰封，万里雪飘”的豪迈与奔放；感受“五岭逶迤腾细浪，乌蒙磅礴走泥丸”的坚定与执着；品味“雄关漫道真如铁，而'}
      ],
    };
  },
  mounted () {
  },
  methods: {
    navigateTo (path) {
      this.$router.push(path);
    },
  }

}
</script>

<style>
.part_title{
  font-size: 18px;
  font-weight: bolder;
  margin-bottom: 10px;
}
.date{
  display: flex;
  justify-content: right;
  font-size:12px;
}
.link{
  text-decoration: none;
  color: #666;
}

.header_nav:hover {
  background-color: #9e070e;
  color: #fff;
}

.el-dropdown-link {
  cursor: pointer;
  color: #fff;
}
.dropdown_menu{
  transform: translate(0,-6%);
  width: 120px;
  .el-dropdown-menu__item{
    text-align: center;
  }
  .el-dropdown-menu__item:hover{
    background-color: #8d080e;
    color: #fff;
  }
}
.dropdown{

}
.dropdown:hover{
  background-color: #9e070e;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
  height: 450px;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}
.center {
  margin: 0 auto;
  width: 1240px;
  display: flex;
  flex-direction: row;
}

.right_box {
  width: 100%;
}

.sidebar h2 {
  font-size: 24px;
  margin-bottom: 20px;
}

.sidebar .nav {
  //background-color: #fafafa;
  transform: translateY(-40%);
  list-style: none;
  padding-bottom: 100px;
  background: linear-gradient(170deg, #fafafa 90%, #fff 10%);
}

.sidebar .nav li {
  cursor: pointer;
  margin-bottom: 5px;
  font-size: 16px;
  padding: 10px;
  transition: background-color 0.3s;
}

.sidebar .nav li:hover {
  color: #6a6a6a;
  background-color: #eee;
}

.sidebar .nav li {
  color: #6a6a6a;
}

.content-section h2 {
  font-size: 24px;
  margin-bottom: 10px;
}

.content-section p {
  font-size: 16px;
  line-height: 1.6;
  color: #555;
}

.title {
  width: 120px;
  height: 50px;
  text-align: center;
  font-size: 22px;
  padding-top: 10px;
  border-bottom: 3px solid #9e070e;
}

.row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.between {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
}

.border_bottom {
  border-bottom: 1px solid #cdcbcc;
}

.left_box {
  display: flex;
}

.left_title {
  background: linear-gradient(-170deg, #9e070e 50%, #fafafa 10%);
  height: 350px;
  padding: 40px 0 0 0;
  color: #FFFFFF;

  div:first-child {
    font-size: 30px;
    margin: 10px;
  }

  div:last-child {
    font-size: 15px;
  }
}

.right_link {
  color: #666;
  font-size: 14px;
}

.part_box {
  padding: 40px 0;
  line-height: 2em;
  display: flex;
  flex-direction: row;
  height: 250px;
  border-bottom: 1px solid #cdcbcc;
  img{
    width: 200px;
    height: 100%;
  }
}
.part{
  color: #666;
  height: 100%;
  margin: 0 20px;
  .content{
    font-size: 12px;
  }
}


</style>



// WEBPACK FOOTER //
// src/views/orient/life/index.vue